import React from 'react';
import PropTypes from 'prop-types';
import { CustomMoneyInput, Text } from '@src/components';

const DailyPrice = ({ dailyPrice, onChange, placeholder = "" }) => {
  const handleDailyPriceChange = (value) => {
    onChange(value);
  };
  return (
    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
      <CustomMoneyInput
        id="ticketRestaurant-balanceUpload-balanceInformation-dailyOrder-dailyPrice-moneyInput"
        value={dailyPrice}
        autoComplete="off"
        height={40}
        width={76}
        onChange={handleDailyPriceChange}
      />
      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
        <span className="info-text" style={{ fontSize: '12px' }}><Text t="tlMonth" /></span>
        <span className="info-text" style={{ fontSize: '12px' }}><Text t="vatIncluded" /></span>
      </div>
    </div>
  );
};

DailyPrice.propTypes = {
  dailyPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

DailyPrice.defaultProps = {
  dailyPrice: 0,
  placeholder: "",
};

export default DailyPrice;
